<template>
  <div class="page-wrapper">
    <HeaderComponent />

    <main class="page-content">
      <AppBreadcrumb :items="[{ label: 'Bosh sahifa' }]" />

      <section class="seo-section" aria-label="AvtoTesting.uz bosh sahifa ma’lumotlari">
        <h1 class="sr-only">
          AvtoTesting.uz — haydovchilik guvohnomasi uchun YHQ testlari
        </h1>
        <p class="sr-only">
          Real imtihon, 10 talik, 20 talik va 50 talik test biletlari, xato savollar,
          jarima ballari va boshqa foydali bo‘limlar.
        </p>
      </section>

      <section class="categories-container" aria-labelledby="categories-title">
        <div class="categories-header">
          <h2 id="categories-title" class="section-title">Bo‘limlar</h2>
          <p class="section-subtitle">
            Imtihonga tayyorlanish uchun kerakli bo‘limlardan birini tanlang
          </p>
        </div>

        <nav class="categories-grid" aria-label="Asosiy bo‘limlar">
          <div
            v-for="item in categories"
            :key="item.title"
            class="category-item"
          >
            <CategoryCard
              :title="item.title"
              :description="item.description"
              :to="item.to"
              :icon="item.icon"
              :badge="item.badge"
              :badge-color="item.badgeColor"
              :disabled="item.disabled"
            />
          </div>
        </nav>
      </section>
    </main>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'
import CategoryCard from '../components/CategoryCard.vue'

export default {
  name: 'HomeView',
  components: {
    HeaderComponent,
    AppBreadcrumb,
    CategoryCard
  },
  data() {
    return {
      categories: [
        {
          title: 'Real imtihon',
          description: 'Asosiy imtihon rejimi',
          to: '/real-exam',
          icon: '📝'
        },
        {
          title: '10 ta biletlar',
          description: '10 talik test biletlari',
          to: '/tickets/10',
          icon: '🔟'
        },
        {
          title: '20 tali biletlar',
          description: '20 talik test biletlari',
          to: '/tickets/20',
          icon: '📚'
        },
        {
          title: '50 tali biletlar',
          description: '50 talik test biletlari',
          to: '/tickets/50',
          icon: '🎯'
        },
        {
          title: 'Xato belgilagan savollarim',
          description: 'Xato ishlangan savollar',
          to: '/wrong-questions',
          icon: '❌'
        },
        {
          title: 'Jarima ballari',
          description: 'Jarima ballari',
          to: '/fine-points',
          icon: '⚠️'
        },
        {
          title: 'Tibbiyot ma’lumotlari',
          description: 'Tibbiy bilimlar',
          to: '/medical-info',
          icon: '🏥',
          badge: 'Jarayonda',
          badgeColor: 'orange',
          disabled: true
        },
        {
          title: 'Yo‘l belgilari',
          description: 'Yo‘l belgilari katalogi',
          to: '/road-signs',
          icon: '🚸',
          badge: 'Jarayonda',
          badgeColor: 'orange',
          disabled: true
        },
        {
          title: 'Jarimalar',
          description: 'Jarimalar ro‘yxati',
          to: '/fines',
          icon: '💸',
          badge: 'Jarayonda',
          badgeColor: 'orange',
          disabled: true
        }
      ]
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
}

.page-content {
  flex: 1;
  padding: 0 24px 32px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.seo-section {
  margin: 0;
  padding: 0;
}

.categories-container {
  margin-top: 24px;
}

.categories-header {
  margin-bottom: 18px;
}

.section-title {
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--text, #111827);
}

.section-subtitle {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary, #6b7280);
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.category-item {
  width: 100%;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Tablet */
@media (max-width: 1024px) {
  .page-content {
    padding: 0 20px 28px;
  }

  .categories-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .section-title {
    font-size: 22px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .page-content {
    padding: 0 16px 24px;
  }

  .categories-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }

  .section-title {
    font-size: 20px;
  }

  .section-subtitle {
    font-size: 13px;
  }
}

/* Small Mobile */
@media (max-width: 576px) {
  .page-content {
    padding: 0 12px 20px;
  }

  .categories-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .section-title {
    font-size: 18px;
  }
}
</style>